<template>
  <span :class="ns.e('simple')" :disabled="disabled">
    <jd-input
      :size="size"
      :class="[ns.e('editor'), ns.is('in-pagination')]"
      :min="1"
      :max="pageCount"
      :disabled="disabled"
      :model-value="innerValue"
      :validate-event="false"
      :label="t('el.pagination.page')"
      type="number"
      @update:model-value="handleInput"
      @change="handleChange"
    />
    <jd-icon :class="ns.e('separator')">
      <component :is="ObliqueLine" />
    </jd-icon>
    <span class="number">
      {{ pageCount }}
    </span>
  </span>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useLocale, useNamespace } from '@jdesign-vue/hooks'
import JdInput from '@jdesign-vue/components/input'
import { ObliqueLine } from '@jd/jdesign-icons-vue'
import { usePagination } from '../usePagination'
import { paginationSimpleProps } from './simple'

defineOptions({
  name: 'JdPaginationSimple',
})

defineProps(paginationSimpleProps)
const { t } = useLocale()
const ns = useNamespace('pagination')
const { pageCount, disabled, currentPage, changeEvent } = usePagination()
const userInput = ref<number | string>()
const innerValue = computed(() => userInput.value ?? currentPage?.value)

function handleInput(val: number | string) {
  userInput.value = val ? +val : ''
}

function handleChange(val: number | string) {
  val = Math.trunc(+val)
  changeEvent?.(val)
  userInput.value = undefined
}
</script>
